import store from '@/store'

const notificationsAPI = {
  // specific notifications api
  url_query: '/api/notifications',

  getLinkedRecipients (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/recipients'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  }
}

export default notificationsAPI



// WEBPACK FOOTER //
// ./src/api/resources/notifications.js